import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import Autocomplete from "@mui/material/Autocomplete";
import React from "react";
import {AutoCompleteMultipleProps} from "./AutoCompleteProps";
import AutocompleteRenderOptionState from "@mui/lab/Autocomplete"


const AutoCompleteMultiple = ({id, options, label, disabled, value, setValue}: AutoCompleteMultipleProps) => {
    // The max number of values that can be selected from the dropdown (5 is a good choice for bar chart, but for a line chart it can be more)

    const maxToSelect = 8
    return (
        <Autocomplete
            id={id}
            multiple
            disableCloseOnSelect
            limitTags={1}
            size="small"
            fullWidth
            options={options}
            value={value}
            disabled={disabled}
            onChange={(event: React.SyntheticEvent, newValue: string[] | undefined) => {
                setValue(newValue)
            }
            }
            renderOption={(props: React.HTMLAttributes<HTMLLIElement>, option: string, {selected}: {selected: boolean}) => {
                const numberOfRemainingOptions = maxToSelect - (value?.length || 0);
                return (
                    <li {...props}>
                        <Tooltip title={`${numberOfRemainingOptions < 1 ? "No" : numberOfRemainingOptions} 
                    more option${numberOfRemainingOptions !== 1 ? "s" : ""} can be selected`}>
                            <FormControlLabel
                                disabled={value?.length! >= maxToSelect && !selected}
                                control={<Checkbox checked={selected}/>}
                                label={option}
                            />
                        </Tooltip>
                    </li>
                )
            }}
            renderInput={(params) => <TextField
                {...params}
                label={`${label} ${value?.length || 0}/${maxToSelect}`}
                variant="outlined"
            />}
        />
    );
}

export default AutoCompleteMultiple;
